import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const FixedBarContainer: StyleRule = ({ theme }) => ({
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
    height: pxToRem(122),
    background: theme.siteVariables.colors.white['000'],
    zIndex: theme.siteVariables.zIndexes.overlay,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});

export const LabelStyling: StyleRule = {
    marginLeft: pxToRem(23),
};

export const ButtonDoneTagging: StyleRule = () => ({
    position: 'absolute !important', //Fela overwrites it with position: relative
    top: pxToRem(25),
    right: pxToRem(20),
});
